import { useGetSaiSurveyPeriodOptionsQuery } from '../../../../graphQL';

export type SurveyOption = {
  id: number;
  name: string;
  isActive: boolean;
  isStudentSearchSupported: boolean;
};

type UseGetSurveyOptionsResult =
  | { status: 'loading' }
  | { status: 'error'; error: string }
  | { status: 'success'; options: SurveyOption[] };

/**
 * The survey periods a provider may view for an organization, newest first. Each carries
 * whether it is the active period and whether the Beacon student surfaces can render it
 * (an older survey is still offered but not searchable — see `isStudentSearchSupported`).
 */
export const useGetSurveyOptions = (organizationId: number): UseGetSurveyOptionsResult => {
  const { data, loading, error } = useGetSaiSurveyPeriodOptionsQuery({
    variables: { organizationId },
  });

  if (loading) {
    return { status: 'loading' };
  }
  if (error) {
    return { status: 'error', error: error.message };
  }
  return { status: 'success', options: data?.getSaiSurveyPeriodOptions ?? [] };
};
